import { CSSObject } from '@chakra-ui/react';
import {
  TAccordionButton,
  TAccordionItem,
  TAccordionPanel,
} from './MarketsByMatch.styles';

export const BoxWrapper: CSSObject = {
  px: ['2', '3'],
};

export const AccordionItem = ({ isNested }: TAccordionItem): CSSObject => ({
  boxShadow: 'none',
  border: 0,
  mb: '2',

  _expanded: {
    boxShadow: 'none',
  },

  ...(isNested && {
    boxShadow: 'none',

    _last: { mb: 0 },
  }),
});

export const AccordionPanel = ({ isNested }: TAccordionPanel): CSSObject => ({
  ...(isNested && {}),
  border: '1px',
  borderTop: 0,
  borderColor: 'alpha.200',
  borderBottomRadius: 'base',
  px: '1',
  py: '2',
});

export const AccordionButton = ({ isNested }: TAccordionButton): CSSObject => ({
  bg: 'gray.50',
  color: 'gray.700',
  border: '1px',
  borderColor: 'gray.200',
  px: '2',
  py: '2.5',
  transition: 'all 0.2s ease-in-out',
  borderRadius: 'base',
  fontWeight: 'bold',
  fontSize: 'sm',

  '.chakra-accordion__icon': {
    boxSize: ['4', '5'],
    border: '1px solid',
    borderColor: 'alpha.700',
    borderRadius: 'full',
    color: 'alpha.700',
    transition: '.3s ease-in-out',
    ml: 'auto',

    _hover: {
      bg: 'alpha.700',
      color: 'white',
    },
  },

  _expanded: {
    color: 'white',
    bg: 'alpha.400',
    borderBottomRadius: 0,
    border: 0,
    p: '2',

    '.chakra-accordion__icon': {
      boxSize: ['4', '5'],
      borderColor: 'white',
      color: 'white',
      transition: '.3s ease-in-out',
    },
  },

  ...(isNested && {
    bg: 'gray.50',

    _expanded: {
      bg: 'gray.50',
      color: 'gray.700',
      borderBottomRadius: 0,
      px: '2',
    },
  }),
});
